import React, { useEffect, useState } from "react";
import '../../universal.css';

import { ATIS_URL } from '../../data/config';

const ATIS = () => {
  const [atisData, setAtisData] = useState([]);
  const [selectedAtisCallsign, setSelectedAtisCallsign] = useState(null);

  useEffect(() => {
    const fetchATIS = async () => {
      try {
        const response = await fetch(ATIS_URL);
        const data = await response.json();
        setAtisData(data);
      } catch (error) {
        console.error("Error fetching ATIS:", error);
      }
    };

    fetchATIS();
    const interval = setInterval(fetchATIS, 20000);
    return () => clearInterval(interval);
  }, []);

  const formatATISText = (textArray) => 
  Array.isArray(textArray) ? textArray.join(" ").replace(/(?<!\d)\.(?!\d)|\.(?=\s)/g, "\n") : "ATIS text not available.";

  // Find selected ATIS object after refresh
  const selectedAtis = atisData.find(atis => atis.callsign === selectedAtisCallsign);

  return (
    <div className="bg-gray-300 text-white h-full overflow-y-auto">
      <div className="flex flex-wrap space-x-2 mb-1 text-xs">
        {atisData.map((atis) => {
          const icao = atis.callsign.replace("_ATIS", "").slice(0, 4);
          const name = atis.callsign.includes("_A_")
            ? `${icao} ARR`
            : atis.callsign.includes("_D_")
            ? `${icao} DEP`
            : icao;

          return (
            <button
              key={atis.callsign}
              className={`p-1 ${selectedAtisCallsign === atis.callsign ? "bg-gray-600" : "bg-gray-400"}`}
              onClick={() => setSelectedAtisCallsign(atis.callsign)}
            >
              {name}
            </button>
          );
        })}
      </div>
      <div className="overflow-y-auto text-black text-xs monospace-font">
        {selectedAtis ? (
          <div className="p-1">
            <p className="small-title mb-2">{selectedAtis.callsign.replace("_", " ").replace("_", "-")} {selectedAtis.frequency}</p>
            <pre className="whitespace-pre-wrap p-2 mb-2" style={{backgroundColor: "#f0f0f0", userSelect: "text"}}>
              {selectedAtis.text_atis ? formatATISText(selectedAtis.text_atis) : "ATIS text not yet available."}
            </pre>
            <p>
              Updated from VATSIM {new Date(selectedAtis.update_time).toISOString().substring(11, 16)}z
            </p>
          </div>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
};

export default ATIS;
